import VoicePresetsPlaceholder from '@/shared/assets/images/voice-presets.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Voice Clone library',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'translate100',
    'voicePresets',
    'voiceCloneSettings',
    'lipSync',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
  ]),
  media: {
    src: VoicePresetsPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.upgradeCustomVoiceModalClickPricing,
  mixpanelOpeningEvent: MixpanelEvents.upgradeCustomVoiceModalShown,
  subtitle: 'Upgrade to Creator Pro to create a Сustom Voice Clone',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
  buttonText: 'Upgrade to Creator Pro',
  content: {
    chip: {
      title: 'Level up dubbing with this and other Pro tools',
    },
    learnMore: {
      title: 'Learn more',
      link: 'https://help.rask.ai/hc/what-is-custom-voice-clone-rask-help-center',
      text: 'about Voice Clone library',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'Creators dubbing in multiple languages and brands maintaining same voice across content.',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'What you can do',
      bullets: [
        'Adjust expressiveness or remove accents',
        'Save customized voice clones or create new ones from scratch',
        'Reuse your cloned voices across unlimited projects',
      ],
    },
  },
  features: [],
  subtitle: 'Make your cloned voice sound exactly right - every time.',
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreator,
};

const CREATOR_PRO_PLAN_CONTENT = {
  ...BASE_CONTENT,
  title: 'Unlock more Voice Clones',
  bulletsHeader: BULLETS_HEADER_TEXT.inCreatorPro,
  buttonText: BUTTON_TEXTS.toBusiness,
  features: getBullets(['voicePresets10', 'translate500', 'glossary', 'simultaneousMultiLanguageTranslation', 'api']),
  subtitle: 'Upgrade to Business to save up to 10 Custom Voice Clones',
};

const BUSINESS_PLAN_CONTENT = {
  ...CREATOR_PRO_PLAN_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inBusiness,
  buttonText: BUTTON_TEXTS.contactUs,
  features: getBullets([
    'voicePresetsUnlimited',
    'translate2000',
    'customPriceForMins',
    'humanInTheLoop',
    'businessContract',
    'personalManager',
  ]),
  mixpanelButtonClickEvent: MixpanelEvents.upgradeCustomVoiceModalClickContactUs,
  subtitle: 'Upgrade to Enterprise to save unlimited Custom Voice Clones',
};

export const VOICE_PRESETS_CONTENT: LimitedFeatureContent = {
  business: BUSINESS_PLAN_CONTENT,
  creator: CREATOR_PLAN_CONTENT,
  creatorPro: CREATOR_PRO_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
